import {SHOULD_COOKIE_BANNER} from "../../utils/constants";
import {isLocalStorageAvailable} from "../isLocalStorageAvailable";

export const shouldShowCookieBanner = () => {
  if (!isLocalStorageAvailable()) {
    return null;
  }
  return localStorage?.getItem(SHOULD_COOKIE_BANNER) === null
};